import LinkBrandAsAnchor from './LinkBrandAsAnchor';

export default LinkBrandAsAnchor;
